import { StylesConfig } from 'react-select'

export const colourStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    height: '100%',
    cursor: 'pointer',
    border: 'none',
    boxShadow: 'none',
    ':active': { border: 'none', boxShadow: 'none' },
    ':hover': { border: 'none', boxShadow: 'none' },
    color: 'var(--gx-color-black) !important'
  }),
  container: (styles) => ({ ...styles, height: '100%', width: '100%', cursor: 'pointer' }),
  input: (styles) => ({ ...styles, height: '100%', width: '100%' }),
  indicatorsContainer: (styles) => ({ ...styles, display: 'none' }),
  valueContainer: (styles) => ({
    ...styles,
    display: 'flex',
    height: '100%',
    borderRadius: '0',
    minWidth: '150px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--gx-color-black) !important'
  }),
  singleValue: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important' }),
  menu: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important' }),
  menuList: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important' }),
  option: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important', cursor: 'pointer' }),
}

export const colourStylesSession: StylesConfig = {
  control: (styles) => ({
    ...styles,
    height: '100%',
    cursor: 'pointer',
    border: 'none',
    boxShadow: 'none',
    ':active': { border: 'none', boxShadow: 'none' },
    ':hover': { border: 'none', boxShadow: 'none' },
    color: 'var(--gx-color-black) !important'
  }),
  container: (styles) => ({ ...styles, height: '100%', width: '100%', cursor: 'pointer' }),
  input: (styles) => ({ ...styles, height: '100%', width: '100%' }),
  indicatorsContainer: (styles) => ({ ...styles, display: 'none' }),
  valueContainer: (styles) => ({
    ...styles,
    display: 'flex',
    height: '100%',
    borderRadius: '0',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--gx-color-black) !important'
  }),
  singleValue: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important' }),
  menu: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important' }),
  menuList: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important' }),
  option: (styles) => ({ ...styles, color: 'var(--gx-color-black) !important', cursor: 'pointer' }),
}